import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Sections.css';

gsap.registerPlugin(ScrollTrigger);

const features = [
  'Buku TLP Fizikal (Hard Copy)',
  'Bonus: Trendline Cheat Sheet',
  'Bonus: Risk Management Calculator',
  'Bonus: Trading Journal Template',
  'Free Shipping Seluruh Malaysia',
  '100% Money-Back Guarantee',
];

export default function OfferSection() {
  const ref = useRef();
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.offer-card', { opacity: 0, y: 50, scale: 0.95 },
        { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: 'power4.out',
          scrollTrigger: { trigger: ref.current, start: 'top 55%' } });
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section className="sec offer" id="offer" ref={ref}>
      <div className="container" style={{ maxWidth: 700 }}>
        <div className="offer-card">
          <div className="offer-glow" />
          <img src="/book-cover.png" alt="Buku TLP - Train Like Pro Player" className="offer-book-img" />
          <span className="pill" style={{ marginBottom: 20 }}>BELI SATU PERCUMA TIGA</span>
          <h2>Pakej Lengkap<br/><span className="gold-grad">Buku TLP</span></h2>
          <div className="offer-price-block">
            <span className="offer-was">RM350</span>
            <div className="offer-now"><span className="offer-rm">RM</span><span className="offer-val">250</span></div>
            <span className="offer-save">Jimat RM100</span>
          </div>
          <ul className="offer-list">
            {features.map((f, i) => (
              <li key={i}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                {f}
              </li>
            ))}
          </ul>
          <button className="btn-gold" style={{ width: '100%' }}
            onClick={() => document.querySelector('#order-form')?.scrollIntoView({ behavior: 'smooth' })}>
            SAYA NAK SEKARANG — RM250
          </button>
          <div className="offer-trust">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            Jaminan wang dikembalikan 100% jika tidak berpuas hati
          </div>
        </div>
      </div>
    </section>
  );
}
